import clsx from 'clsx';
import {
  BarChart3,
  ChevronRight,
  FileText,
  LayoutDashboard,
} from 'lucide-react';
import { type FC, type ReactNode, useState } from 'react';

import styles from './ArtifactCard.module.scss';

export type ArtifactKind = 'chart' | 'form' | 'widget';

const ICONS: Record<ArtifactKind, typeof BarChart3> = {
  chart: BarChart3,
  form: FileText,
  widget: LayoutDashboard,
};

export interface ArtifactCardProps {
  title: string;
  kind: ArtifactKind;
  children: ReactNode;
}

export const ArtifactCard: FC<ArtifactCardProps> = ({
  title,
  kind,
  children,
}) => {
  const [expanded, setExpanded] = useState(true);
  const Icon = ICONS[kind];

  if (!expanded) {
    return (
      <div className={styles.artifact}>
        <button
          type={'button'}
          className={styles.collapsedTrigger}
          aria-expanded={false}
          onClick={() => setExpanded(true)}
          data-testid={'agent-artifact-toggle'}
        >
          <ChevronRight
            size={14}
            aria-hidden={true}
            className={styles.collapsedChevron}
          />
          {title}
        </button>
      </div>
    );
  }

  return (
    <div className={styles.artifact}>
      <div className={styles.card}>
        <button
          type={'button'}
          className={styles.header}
          aria-expanded={true}
          onClick={() => setExpanded(false)}
          data-testid={'agent-artifact-toggle'}
        >
          <Icon size={16} aria-hidden={true} className={styles.headerIcon} />
          <span className={styles.headerTitle} title={title}>
            {title}
          </span>
          <ChevronRight
            size={16}
            aria-hidden={true}
            className={clsx(styles.headerChevron, styles.chevronOpen)}
          />
        </button>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
};
